import React from 'react';
import {
  Container,
  Row,
  Card,
  Col,
  Button,
  Tooltip,
  OverlayTrigger,
} from 'react-bootstrap';
import { useEffect } from 'react';
import { useState } from 'react';
import ActionRequestService from '../../services/action-request';
import { WidgetsOutlined, Add, ArrowBackIos, Description } from '@material-ui/icons';
import ActionList from './List';
import Can from 'components/Can';
import { Link, useHistory } from 'react-router-dom'
import { useCompany, useProfile, useUser } from 'models';
import "./style.scss";
import NavBar from 'components/NavBar';
import {
  useParams
} from "react-router-dom";

export default function () {
  const user = useUser();
  const profile = useProfile()
  const { fiscal_year } = useParams();
  const { company: currentCompany } = useCompany()
  const fiscalYear = 12

  // const { id: fiscalYear } = fiscal_year != undefined 
  //   ? user.fiscal_years.filter(a => a.fiscal_year === fiscal_year)[0]
  //   : JSON.parse(localStorage.getItem("Elite:fiscalYear"))
  
  const [status, setStatus] = useState([]);
  const [countActions, setCountActions] = useState([]);
  const [flowSelected, setFlowSelected] = useState(1);

  // const filtered = user.fiscal_years.filter(a => a.fiscal_year === fiscal_year)
  // const fiscalYearId = filtered.length > 0 ? filtered[0].id : fiscalYear

  const history = useHistory();

  useEffect(() => {
    getFlows();
    getActions(12);
  }, []);

  const getFlows = () => {
    let request = ActionRequestService.getFlow(3);
    request.then((data) => {
      let r = data.data.data;
      r.user_steps = [];
      if (user.profile.steps)
        user.profile.steps.forEach((step) => {
          if (r.id === step.flow_id) {
            r.user_steps[step.id] = step;
          }
        });
      setStatus(Object.values(r.action_status));
    });
  };

  const getProfile = () => {
    return user.profile
  };

  const getActions = (fiscal_year_id = null, company_id = null) => {
    var filter = {
      fiscal_year_id: fiscal_year_id ?? fiscalYear,
      __fund_type_id: 3,
      company_id: company_id ?? currentCompany ? currentCompany.id : null
    };

    ActionRequestService.amountByStatus({ params: { ...filter } }).then(
      (data) => {
        setCountActions(data.data.data);
      }
    );
  };
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Período de bloqueio para solicitação de novas ações. A partir do dia
      primeiro do mês seguinte o sistema será reaberto para novas solicitações.
      Dúvidas consulte a seção de Perguntas e Respostas (FAQ).
    </Tooltip>
  );
  const getDay = () => {
    let a = new Date();
    return a.getDate();
  };

  const getMonth = () => {
    return new Date().getMonth() + 1
  }

  // const changeFiscalYear = (id) => {
  //   const filter = {
  //     fiscal_year_id: id
  //   };
  //   if(currentCompany){
  //     filter.company_id = currentCompany
  //       ? currentCompany.id
  //       : user.currentCompany.id;

  //     let companies = ResalesRequestService.getGroupHeadquarter({
  //       params: { ...filter },
  //     });
  //     companies.then((data) => {
  //       let c = data.data.data;
  //       // setCompanyId(data.data.data.company_id)
  //       // setFiscalYear(id);
  //       getActions(parseInt(id), c.company_id);
  //     });
  //   }else{
  //     // setFiscalYear(id);
  //     getActions(parseInt(id))
  //   }
  // }

  // const getSizeNavItem = () => {
  //   let width = window.innerWidth;
  //   if(width <= 341){
  //     return {width:'51%'}
  //   }
  //   else if(width <= 441){
  //     return {width:'34%'}
  //   }
  //   else if(width <= 767){
  //     return {width:'26%'}
  //   }
  //   return {};
  // }

  const date = new Date()
  const now = `0${date.getDate()}/0${date.getMonth()+1}`

  function isDateEqualOrBefore(dateStr) {
    // Converter a string para um objeto Date
    const [day, month] = dateStr.split('/').map(Number); // Divide a string e converte para números
    const currentDate = new Date(); // Data atual para referência do ano
    const year = currentDate.getFullYear(); // Usar o ano atual

    // Criar objeto Date para a data fornecida
    const inputDate = new Date(year, month - 1, day); // O mês começa em 0 (Janeiro é 0)

    // Data de referência para comparação (05/09 do ano atual)
    const referenceDate = new Date(year, 8, 5); // 8 é Setembro (mês é zero-indexado)

    // Verificar se a data fornecida é igual ou anterior a 05/09
    return inputDate <= referenceDate;
  }

  return (
    <Container fluid>
      <Row className="mt-4">
        <Button variant="link" className="link-back" onClick={() => history.goBack()}>
          <ArrowBackIos className="icon-title icon-back" />
          <h6 className="font-13 mt-3">Voltar</h6>
        </Button>
      </Row>
      <Row className="mt-3 align-items-end justify-content-between">
        <Col xs="auto" className="d-flex">
          <WidgetsOutlined className="icon-title" />
          <h5 className="title-dashboard">Fluxo de ScanCash{!!fiscal_year ? ` - ${fiscal_year}` : ""}</h5>
        </Col>
        <Col xs="auto">
          <Row>
            {/* {!!fiscal_year ? (
              <></>
            ) : (
              <Col xs="auto" className="text-right">
                <span className="text-right text-danger font-weight-bold">Resgate para abatimento no pedido indisponível no momento.</span><br />
              </Col>
            )} */}
          </Row>
        </Col>
      </Row>
      <Row>
        <Card.Body className="card-dashboard shadow bg-white rounded text-center m-2 col-12">
          <Row className="mt-2 mb-2">
            <Col xs='12' md='6' className="text-left">
              {!!fiscal_year ? (
                <></>
              ) : (<>
                <Can do="scancash.create" on="App">
                  {(isDateEqualOrBefore(now) || getDay() > 20 && getDay() <= 31 && getProfile() != 'Administrador') ? (<>
                    {profile.havePermission("action.add-out-period") || !isDateEqualOrBefore(now) || getMonth() == 12 ? (
                      <Link to="/elite/scancash/show">
                        <Button className="btn-add">
                          <Add /> Solicitar Resgate
                        </Button>
                      </Link>
                    ) : (
                      <OverlayTrigger
                        placement="right"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltip}
                      >
                        <Button
                          variant="light"
                          onClick={(e) => {
                            e.target.className = e.target.className.replace(
                              'btn-light',
                              'btn-reject btn-danger'
                            );
                            const parar = () => {
                              let element = document.getElementsByClassName(
                                'btn-reject'
                              )[0];
                              if (element)
                                element.className = element.className.replace(
                                  'btn-reject btn-danger',
                                  'btn-light'
                                );
                            };
                            window.setTimeout(parar, 500);
                          }}
                        >
                          <Add />
                          Solicitar Resgate
                        </Button>
                      </OverlayTrigger>
                    )}
                  </>) : (<>
                    <Link to="/elite/scancash/show">
                      <Button className="btn-add">
                        <Add /> Solicitar Resgate
                      </Button>
                    </Link>
                  </>)}
                </Can>
              </>)}
              {currentCompany ? (
                <Link to="/elite/scancash/fund">
                  <Button className='ml-2'>
                    <Description /> Extrato de Verbas
                  </Button>
                </Link>
              ) : <></>}
              <Can on="App" do="scancash.deductions">
                <Link to="/elite/deductions">
                  <Button variant='info' className='ml-2'>
                    <Description /> Deduções
                  </Button>
                </Link>
              </Can>
            </Col>
          </Row>
          <Row>
            <Col xs="12">
              <NavBar addAll onChange={(key) => {
                setFlowSelected(key)
              }}>
                {status.map((item, k) => {
                  let quantity = countActions[item.id] ? countActions[item.id].amount : 0;
                  let list = [6, 7, 11]
                  return (
                    <NavBar.Item
                      key={k}
                      eventKey={item.id}
                      title={item.name}
                      quantity={quantity}
                      hiddenEmpty={list.indexOf(item.id) !== -1}
                    />
                  )
                })}
              </NavBar>
            </Col>
          </Row>
          <ActionList
            user={user}
            currentCompany={currentCompany}
            flowSelected={flowSelected}
            fiscalYear={fiscalYear}
          />
        </Card.Body>
      </Row>
    </Container>
  );
};
